<!-- 组件说明 -->
<template>
  <div class="con">
    <div class="con bread-crumb-container">
      <span>您现在的位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span @click="back" class="c-pointer"
            >厂家活动</span
          ></el-breadcrumb-item
        >
        <el-breadcrumb-item>活动详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="banner">
      <img v-lazy="imgurl" alt="" />
    </div>
    <div class="list-header">
      <div class="title">
        <i></i>
        <span>活动商品</span>
      </div>
      <div class="listBtn">
        <div
          class="list c-pointer"
          :class="{ active: type == 1 }"
          @click="showList"
        >
          <img
            :src="require('@/assets/images/icon_c1.png')"
            v-if="type == 2"
            alt=""
          />
          <img :src="require('@/assets/images/icon_c2.png')" v-else alt="" />
          <span>列表</span>
        </div>
        <div
          class="table c-pointer"
          :class="{ active: type == 2 }"
          @click="showTable"
        >
          <img
            :src="require('@/assets/images/icon_d1.png')"
            v-if="type == 1"
            alt=""
          />
          <img :src="require('@/assets/images/icon_d2.png')" v-else alt="" />
          <span>表格</span>
        </div>
      </div>
    </div>

    <!-- 商品列表 -->
    <goodslistceil2
      v-if="type == 1"
      :goodsList="detailList"
      :status="2"
    ></goodslistceil2>
    <goodslistceil v-else :goodsList="detailList" :status="2"></goodslistceil>
  </div>
</template>

<script>
import goodslistceil from "@/components/goods-list-ceil";
import goodslistceil2 from "@/components/goods-list-ceil-2";
import axios from "axios";
export default {
  components: { goodslistceil, goodslistceil2 },
  props: ["id"],
  data() {
    return {
      type: 1, //1列表  2表格
      imgurl: "",
      detailList: [],
      activityList: [
        { name: "厂家活动", path: "/activities" },
        { name: "活动详情" },
      ],
    };
  },
  computed: {},
  methods: {
    showList() {
      this.type = 1;
    },
    showTable() {
      this.type = 2;
    },
    getdetail() {
      this.$api.GET_ACTIVITYDETAIL(this.id).then((res) => {
        if (res.status) {
          this.imgurl = res.data.image;
          this.detailList = res.data.activeFactoryGoodsListResult;
          //console.log(res);
        }
      });
    },
    back() {
      this.$parent.changeType();
    },
  },
  created() {
    this.getdetail();
  },
};
</script>

<style lang='scss' scoped>
.banner {
  height: 846px;
  width: 1200px;
  img {
    @include size(100%, 100%);
  }
}
.title {
  display: flex;
  align-items: center;
  i {
    display: inline-block;
    height: 18px;
    width: 4px;
    background-color: #fa4b4b;
    margin-right: 16px;
  }
  span {
    font-size: 16px;
    color: #333333;
  }
}
.list-header {
  display: flex;
  justify-content: space-between;
  margin: 22px 0 24px 0;
}

.listBtn {
  display: flex;
  border-radius: 3px;
  .list,
  .table {
    width: 72px;
    height: 26px;
    @include font(13px, #666666, center, 400, 26px);
    img {
      margin-right: 5px;
    }
  }
  .list {
    border: 1px solid #eeeeee;
    border-radius: 3px 0 0 3px;
  }
  .table {
    border: 1px solid #eeeeee;
    border-radius: 0 3px 3px 0;
    img {
      margin-bottom: -1px;
    }
  }
}
.active {
  color: #f43737 !important;
  border-color: #f43737 !important;
}
.bread-crumb-container {
  color: #808080;
  font-size: 13px;
  margin: 18px auto;
  display: flex;
  /deep/ .el-breadcrumb__inner {
    font-size: 13px !important;
    color: #808080 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/activities/components/activities-detail.vue